import React, { PureComponent } from "react";
import SvgIcon from "material-ui/SvgIcon";
/** @augments {PureComponent<any, any>} */
class CartOutlined extends PureComponent {
    render() {
        return (
            <SvgIcon {...this.props}>
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g transform="translate(-1282.000000, -21.000000)">
                        <g transform="translate(60.000000, 0.000000)">
                            <g transform="translate(949.000000, 10.000000)">
                                <g transform="translate(244.000000, 0.000000)">
                                    <g transform="translate(29.000000, 11.000000)">
                                        <rect x="0" y="0" width="18" height="18"></rect>
                                        <g
                                            transform="translate(0.750000, 1.500000)"
                                            stroke="#FFFFFF"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        >
                                            <path
                                                d="M0,0 L3,0 L5.01,10.0422511 C5.15155272,10.7549071 5.78353795,11.2636426 6.51,11.2497211 L13.8,11.2497211 C14.526462,11.2636426 15.1584473,10.7549071 15.3,10.0422511 L16.5,3.74990705 L3.75,3.74990705"
                                                strokeWidth="1.5"
                                            ></path>
                                            <line
                                                x1="13.8721875"
                                                y1="14.28125"
                                                x2="13.8778125"
                                                y2="14.28125"
                                                strokeWidth="2"
                                            ></line>
                                            <line
                                                x1="5.6221875"
                                                y1="14.28125"
                                                x2="5.6278125"
                                                y2="14.28125"
                                                strokeWidth="2"
                                            ></line>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </SvgIcon>
        );
    }
}

export default CartOutlined;
